import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

import { Mode, HeaderTitle, IHeaderItem } from './../../models/generic';
import { DataService } from 'src/app/services/data.service';
import { ApiLotDetailService } from 'src/app/services/api/api-lot-detail.service';

@Component({
  selector: 'app-lote-repasse',
  templateUrl: './lotes-repasse.component.html',
  styleUrls: ['./lotes-repasse.component.scss']
})
export class LotesRepasseComponent implements OnInit, OnDestroy {
  routeDetailSubscription!: Subscription;

  Mode = Mode;

  title: HeaderTitle = 'Repasse de Comissão';

  headerItems: IHeaderItem[] = [
    { label: '#', flexSize: 1, justify: 'flex-start' },
    { label: '', flexSize: 1 },
    { label: '', flexSize: 1 },
    { label: 'Status', flexSize: 2 },
    { label: 'Lote', flexSize: 4 },
    { label: 'Banco', flexSize: 4 },
    {
      label: 'Parceiro',
      flexSize: 4,
      name: 'Partner',
      isOrder: true,
      orderValue: 0
    },
    { label: 'Status do Pagamento', flexSize: 4 },
    {
      label: 'Data do Lote',
      flexSize: 4,
      name: 'CreateDate',
      isOrder: true,
      orderValue: 0
    },
    {
      label: 'Data de envio e-mail',
      flexSize: 4,
      name: 'EmailTransferDate',
      isOrder: true,
      orderValue: 0
    },
    {
      label: 'Data e-mail pgto',
      flexSize: 4,
      name: 'EmailEstimatedPaymentDate',
      isOrder: true,
      orderValue: 0
    },
    {
      label: 'Valor do Repasse',
      flexSize: 4,
      name: 'AmountTotal',
      isOrder: true,
      orderValue: 0
    },
    {
      label: 'Qt. de Contratos',
      flexSize: 4,
      name: 'NumberOfContracts',
      isOrder: true,
      orderValue: 0
    },
    {
      label: 'Status do Lote',
      flexSize: 4,
      name: 'StatusOfOnlending',
      isOrder: true,
      orderValue: 0
    },
    { label: '', flexSize: 1 }
  ];

  constructor(
    private _dataService: DataService,
    private _activatedRoute: ActivatedRoute,
    private _lotDetailService: ApiLotDetailService,
    private _router: Router
  ) {
    const title = _activatedRoute.snapshot.routeConfig?.title as HeaderTitle;
    this._dataService.setHeaderTitle(title);
  }

  ngOnInit() {
    this.listeningEvents();
  }

  ngOnDestroy(): void {
    if (this.routeDetailSubscription) {
      this.routeDetailSubscription.unsubscribe();
    }
  }

  listeningEvents(): void {
    // Repasse so tem lotes Type='Manual' em producao hoje (confirmado no
    // banco, 2026-08-28) — sempre vai pra tela v2.
    this._lotDetailService.routeToDetailEvent.subscribe((lotInfo) => {
      this._router.navigate(['detalhes-lote-manual-v2', lotInfo.lotId], {
        relativeTo: this._activatedRoute
      });
    });
  }
}
